/**
 * m3 echo Frontend - Tools Page
 *
 * Tools page with tabbed interface for admin tools.
 */

import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import { useUIStore } from '../stores/useUIStore';

// Tab components
import ModelComparisonTab from '../components/tools/ModelComparisonTab';
import CustomAutopilotTab from '../components/tools/CustomAutopilotTab';
import GroundingBenchmarkTab from '../components/tools/GroundingBenchmarkTab';
import InsightsTab from '../components/tools/InsightsTab';
import CutoffsTab from '../components/tools/CutoffsTab';
import Layer5BenchmarkTab from '../components/tools/Layer5BenchmarkTab';
import JobDetailDialog from '../components/JobDetailDialog';
import AnimatedTabPanel from '../components/AnimatedTabPanel';

const tabs = [
  { label: 'Layer2 Vergleich', key: 'layer2-comparison' },
  { label: 'Custom Autopilot', key: 'custom-autopilot' },
  { label: 'Grounding Benchmark', key: 'grounding-benchmark' },
  { label: 'Layer5 Benchmark', key: 'layer5-benchmark' },
  { label: 'Insights', key: 'insights' },
  { label: 'Cutoffs', key: 'cutoffs' },
];

export const Tools: React.FC = () => {
  const { toolsActiveTab, setToolsTab } = useUIStore();

  // Bounds check for persisted tab state
  useEffect(() => {
    if (toolsActiveTab >= tabs.length) {
      setToolsTab(0);
    }
  }, [toolsActiveTab, setToolsTab]);

  // Ensure we don't render with invalid tab index
  const safeTabIndex = toolsActiveTab < tabs.length ? toolsActiveTab : 0;

  return (
    <Box>
      <Typography variant="h5" component="h1" sx={{ mb: 3 }}>
        Tools
      </Typography>

      <Paper>
        <Tabs
          value={safeTabIndex}
          onChange={(_, newValue) => setToolsTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>

        {/* Layer2 Vergleich Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={0}>
          <ModelComparisonTab />
        </AnimatedTabPanel>

        {/* Custom Autopilot Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={1}>
          <CustomAutopilotTab />
        </AnimatedTabPanel>

        {/* Grounding Benchmark Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={2}>
          <GroundingBenchmarkTab />
        </AnimatedTabPanel>

        {/* Layer5 Benchmark Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={3}>
          <Layer5BenchmarkTab />
        </AnimatedTabPanel>

        {/* Insights Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={4}>
          <InsightsTab />
        </AnimatedTabPanel>

        {/* Cutoffs Tab */}
        <AnimatedTabPanel value={safeTabIndex} index={5}>
          <CutoffsTab />
        </AnimatedTabPanel>
      </Paper>

      {/* Job Detail Dialog - for viewing job details from Custom Autopilot runs */}
      <JobDetailDialog />
    </Box>
  );
};

export default Tools;
